"use strict";

angular.module("customer")
.controller("UserPartnershipController", function(
        $cookies, $timeout, $scope, $state, $stateParams, $q, FlashBag, gettextCatalog, StateExtensionService,
        UserService, ModalService, PartnershipService, UserPartnershipService, UserCustomerService, GroupService,
        NoOrderNotificationService, OrderConsolidationService, SalesRepPartnershipTagService,
        UnpaidInvoicesStatementPrintButtonService, ORDER_DEADLINE_LATE_HOURS, IS_MOBILE_APP
) {
    var _this = this;
    $scope.params = $stateParams;
    $scope.cachedFilters = $cookies.getObject("filters");
    if (!$scope.cachedFilters || !$scope.cachedFilters.hasOwnProperty($state.current.name)) {
        $scope.cachedFilters = {};
        $scope.cachedFilters[$state.current.name] = {};

        var expirationDaysDelta = 1;
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + expirationDaysDelta);
        $cookies.putObject("filters", $scope.cachedFilters, {expires: expirationDate});
    } else if($scope.cachedFilters.hasOwnProperty($state.current.name)) {
        $scope.params = angular.extend($scope.params, $scope.cachedFilters[$state.current.name]);
    }

    $scope.defaultUnpaidInvoicesStatementPrintFormat = UnpaidInvoicesStatementPrintButtonService.PDF_LETTER_FORMAT;
    if (IS_MOBILE_APP) {
        $scope.defaultUnpaidInvoicesStatementPrintFormat = UnpaidInvoicesStatementPrintButtonService.PDF_RECEIPT_FORMAT;
    }

    $scope.pagination = {};
    $scope.salesRepUnpaidInvoicesSummary = null;
    $scope.showDistributorRoutes = false;
    $scope.salesRepPartnershipTagService = SalesRepPartnershipTagService;

    this.getDisabledButtonReturnConsolidationHelpTipHtmlContent = function() {
        return gettextCatalog.getString("Only one return consolidation per day is allowed.");
    };

    $scope.lastOrderFilterHelpTip = UserPartnershipService.getLastOrderFilterHtmlContent();
    $scope.lastInvoiceFilterHelpTip = UserPartnershipService.getLastInvoiceFilterHtmlContent();
    $scope.orderDeadlineFilterHelpTip = UserPartnershipService.getOrderDeadlineFilterHtmlContent();
    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        $scope.lastOrderFilterHelpTip = UserPartnershipService.getLastOrderFilterHtmlContent();
        $scope.lastInvoiceFilterHelpTip = UserPartnershipService.getLastInvoiceFilterHtmlContent();
        $scope.orderDeadlineFilterHelpTip = UserPartnershipService.getOrderDeadlineFilterHtmlContent();
    });

    var endOfDay = moment().endOf('day');
    var startOfDay = moment().startOf('day');
    $scope.filters = {};

    $scope.LAST_INVOICE_DATE_FILTER_ALL = 'all';
    $scope.LAST_INVOICE_FILTER_LAST_2_WEEKS = 'last_2_weeks';
    $scope.LAST_INVOICE_FILTER_LAST_4_WEEKS = 'last_4_weeks';
    $scope.LAST_INVOICE_FILTER_LAST_6_WEEKS = 'last_6_weeks';
    $scope.LAST_INVOICE_FILTER_NO_INVOICES = 'no_invoices';
    $scope.LAST_INVOICE_FILTER_CUSTOM = 'custom';

    $scope.lastInvoiceDateOptions = [{
        value: $scope.LAST_INVOICE_FILTER_CUSTOM,
        label: gettextCatalog.getString("Filter by Last Invoice Date...", null, "Mobile Last Invoice date filter")
    }, {
        value: $scope.LAST_INVOICE_DATE_FILTER_ALL,
        label: gettextCatalog.getString("All", null, "Mobile Last Invoice date filter")
    }, {
        value: $scope.LAST_INVOICE_FILTER_LAST_2_WEEKS,
        label: gettextCatalog.getString("2 W", null, "Mobile Last Invoice date filter")
    }, {
        value: $scope.LAST_INVOICE_FILTER_LAST_4_WEEKS,
        label: gettextCatalog.getString("4 W", null, "Mobile Last Invoice date filter")
    }, {
        value: $scope.LAST_INVOICE_FILTER_LAST_6_WEEKS,
        label: gettextCatalog.getString("6 W", null, "Mobile Last Invoice date filter")
    }, {
        value: $scope.LAST_INVOICE_FILTER_NO_INVOICES,
        label: gettextCatalog.getString("No invoices", null, "Mobile Last Invoice date filter")
    }];

    $scope.filters["selectedLastInvoiceDateFilter"] = $scope.params.last_invoice_date_filter || $scope.LAST_INVOICE_DATE_FILTER_ALL;
    $scope.lastInvoiceDateFilters = {}
    $scope.lastInvoiceDateFilters[$scope.LAST_INVOICE_DATE_FILTER_ALL] = {
        last_invoice_date_start: undefined,
        last_invoice_date_end: undefined,
        has_last_invoice: undefined
    };
    $scope.lastInvoiceDateFilters[$scope.LAST_INVOICE_FILTER_LAST_2_WEEKS] = {
        last_invoice_date_start: undefined,
        last_invoice_date_end: moment(endOfDay).subtract(2, "weeks").toISOString(),
        has_last_invoice: undefined
    };
    $scope.lastInvoiceDateFilters[$scope.LAST_INVOICE_FILTER_LAST_4_WEEKS] = {
        last_invoice_date_start: undefined,
        last_invoice_date_end: moment(endOfDay).subtract(4, "weeks").toISOString(),
        has_last_invoice: undefined
    };
    $scope.lastInvoiceDateFilters[$scope.LAST_INVOICE_FILTER_LAST_6_WEEKS] = {
        last_invoice_date_start: undefined,
        last_invoice_date_end: moment(endOfDay).subtract(6, "weeks").toISOString(),
        has_last_invoice: undefined
    };
    $scope.lastInvoiceDateFilters[$scope.LAST_INVOICE_FILTER_NO_INVOICES] = {
        last_invoice_date_start: undefined,
        last_invoice_date_end: undefined,
        has_last_invoice: false
    };
    $scope.lastInvoiceDateFilters[$scope.LAST_INVOICE_FILTER_CUSTOM] = {
        has_last_invoice: undefined
    };

    $scope.LAST_ORDER_DATE_FILTER_ALL = 'all';
    $scope.LAST_ORDER_FILTER_LAST_2_WEEKS = 'last_2_weeks';
    $scope.LAST_ORDER_FILTER_LAST_4_WEEKS = 'last_4_weeks';
    $scope.LAST_ORDER_FILTER_LAST_6_WEEKS = 'last_6_weeks';
    $scope.LAST_ORDER_FILTER_NO_ORDERS = 'no_orders';
    $scope.LAST_ORDER_FILTER_CUSTOM = 'custom';

    $scope.lastOrderDateOptions = [{
        value: $scope.LAST_ORDER_FILTER_CUSTOM,
        label: gettextCatalog.getString("Filter by Last Order Date...", null, "Mobile Last Order date filter")
    }, {
        value: $scope.LAST_ORDER_DATE_FILTER_ALL,
        label: gettextCatalog.getString("All", null, "Mobile Last Order date filter")
    }, {
        value: $scope.LAST_ORDER_FILTER_LAST_2_WEEKS,
        label: gettextCatalog.getString("2 W", null, "Mobile Last Order date filter")
    }, {
        value: $scope.LAST_ORDER_FILTER_LAST_4_WEEKS,
        label: gettextCatalog.getString("4 W", null, "Mobile Last Order date filter")
    }, {
        value: $scope.LAST_ORDER_FILTER_LAST_6_WEEKS,
        label: gettextCatalog.getString("6 W", null, "Mobile Last Order date filter")
    }, {
        value: $scope.LAST_ORDER_FILTER_NO_ORDERS,
        label: gettextCatalog.getString("No Orders", null, "Mobile Last Order date filter")
    }];

    $scope.filters["selectedLastOrderDateFilter"] = $scope.params.partnership_last_order_date_filter || $scope.LAST_ORDER_DATE_FILTER_ALL;
    $scope.lastOrderDateFilters = {}
    $scope.lastOrderDateFilters[$scope.LAST_ORDER_DATE_FILTER_ALL] = {
        partnership_last_order_date_start: undefined,
        partnership_last_order_date_end: undefined,
        has_partnership_last_order: undefined
    };
    $scope.lastOrderDateFilters[$scope.LAST_ORDER_FILTER_LAST_2_WEEKS] = {
        partnership_last_order_date_start: undefined,
        partnership_last_order_date_end: moment(endOfDay).subtract(2, "weeks").toISOString(),
        has_partnership_last_order: undefined
    };
    $scope.lastOrderDateFilters[$scope.LAST_ORDER_FILTER_LAST_4_WEEKS] = {
        partnership_last_order_date_start: undefined,
        partnership_last_order_date_end: moment(endOfDay).subtract(4, "weeks").toISOString(),
        has_partnership_last_order: undefined
    };
    $scope.lastOrderDateFilters[$scope.LAST_ORDER_FILTER_LAST_6_WEEKS] = {
        partnership_last_order_date_start: undefined,
        partnership_last_order_date_end: moment(endOfDay).subtract(6, "weeks").toISOString(),
        has_partnership_last_order: undefined
    };
    $scope.lastOrderDateFilters[$scope.LAST_ORDER_FILTER_NO_ORDERS] = {
        partnership_last_order_date_start: undefined,
        partnership_last_order_date_end: undefined,
        has_partnership_last_order: false
    };
    $scope.lastOrderDateFilters[$scope.LAST_ORDER_FILTER_CUSTOM] = {
        has_partnership_last_order: undefined
    };

    $scope.ORDER_DEADLINE_FILTER_ALL = 'all';
    $scope.ORDER_DEADLINE_FILTER_TODAY = 'today';
    $scope.ORDER_DEADLINE_FILTER_2_HOURS = '2_hours';
    $scope.ORDER_DEADLINE_FILTER_LATE = 'late';
    $scope.ORDER_DEADLINE_FILTER_ORDERED = 'ordered';
    $scope.ORDER_DEADLINE_FILTER_CUSTOM = 'custom';

    $scope.orderDeadlineOptions = [{
        value: $scope.ORDER_DEADLINE_FILTER_CUSTOM,
        label: gettextCatalog.getString("Filter by Deadline...", null, "Mobile Order Deadline filter")
    }, {
        value: $scope.ORDER_DEADLINE_FILTER_ALL,
        label: gettextCatalog.getString("All", null, "Mobile Order Deadline filter")
    }, {
        value: $scope.ORDER_DEADLINE_FILTER_TODAY,
        label: gettextCatalog.getString("Today", null, "Mobile Order Deadline filter")
    }, {
        value: $scope.ORDER_DEADLINE_FILTER_2_HOURS,
        label: gettextCatalog.getString("2 hrs", null, "Mobile Order Deadline filter")
    }, {
        value: $scope.ORDER_DEADLINE_FILTER_LATE,
        label: gettextCatalog.getString("Late", null, "Mobile Order Deadline filter")
    }, {
        value: $scope.ORDER_DEADLINE_FILTER_ORDERED,
        label: gettextCatalog.getString("Ordered", null, "Mobile Order Deadline filter")
    }];

    $scope.filters["selectedOrderDeadlineFilter"] = $scope.params.order_deadline_filter || $scope.ORDER_DEADLINE_FILTER_ALL;
    $scope.orderDeadlineFilters = {}
    $scope.orderDeadlineFilters[$scope.ORDER_DEADLINE_FILTER_ALL] = {
        delivery_date_start: undefined,
        delivery_date_end: undefined,
        deadline_date_start: undefined,
        deadline_date_end: undefined,
        next_delivery_has_ordered: undefined
    };
    $scope.orderDeadlineFilters[$scope.ORDER_DEADLINE_FILTER_TODAY] = {
        delivery_date_start: undefined,
        delivery_date_end: undefined,
        deadline_date_start: startOfDay.toISOString(),
        deadline_date_end: endOfDay.toISOString(),
        next_delivery_has_ordered: false
    };
    $scope.orderDeadlineFilters[$scope.ORDER_DEADLINE_FILTER_2_HOURS] = {
        delivery_date_start: undefined,
        delivery_date_end: undefined,
        deadline_date_start: moment().toISOString(),
        deadline_date_end: moment().add(2, "hours").toISOString(),
        next_delivery_has_ordered: false
    };
    $scope.orderDeadlineFilters[$scope.ORDER_DEADLINE_FILTER_LATE] = {
        delivery_date_start: undefined,
        delivery_date_end: undefined,
        deadline_date_start: startOfDay.toISOString(),
        deadline_date_end: moment().toISOString(),
        next_delivery_has_ordered: false
    };
    $scope.orderDeadlineFilters[$scope.ORDER_DEADLINE_FILTER_ORDERED] = {
        delivery_date_start: undefined,
        delivery_date_end: undefined,
        deadline_date_start: undefined,
        deadline_date_end: undefined,
        next_delivery_has_ordered: true
    };
    $scope.orderDeadlineFilters[$scope.ORDER_DEADLINE_FILTER_CUSTOM] = {
        next_delivery_has_ordered: undefined
    };

    UserCustomerService.release().then(function onSuccess(user) {
        var deferred = $q.defer();
        if (user && !!user.global_dedicated_vendor_id) {
            $scope.dedicatedUserVendor = user.dedicated_user_vendor;
            if ($scope.dedicatedUserVendor.is_financial_status_enabled) {
                $scope.salesRepUnpaidInvoicesSummary = UserPartnershipService.getUnpaidInvoicesStatementSummary();
            }

            $scope.showDistributorRoutes = (
                $scope.dedicatedUserVendor.order_consolidation_distributor_config === "per_distributor_per_route"
            );
            OrderConsolidationService.getPartnerships().$promise.then(function onSuccess(data) {
                $scope.orderConsolidationPartnerships = data;
                deferred.resolve();
            }, deferred.reject);
        }
        else {
            deferred.resolve();
        }
        return deferred.promise;
    }).then(function onSuccess() {
        _this.fetch();
    });

    this.filterByLastOrderDate = function(filter) {
        $scope.filters.selectedLastOrderDateFilter = filter;
        _this.fetch();
    };

    this.isLastOrderDateFilterActive = function(filter) {
        return $scope.filters.selectedLastOrderDateFilter === filter;
    };

    this.filterByLastInvoiceDate = function(filter) {
        $scope.filters.selectedLastInvoiceDateFilter = filter;
        _this.fetch();
    };

    this.isLastInvoiceDateFilterActive = function(filter) {
        return $scope.filters.selectedLastInvoiceDateFilter === filter;
    };

    this.filterByOrderDeadline = function(filter) {
        $scope.filters.selectedOrderDeadlineFilter = filter;
        _this.fetch();
    };

    this.isOrderDeadlineFilterActive = function(filter) {
        return $scope.filters.selectedOrderDeadlineFilter === filter;
    };

    this.isOrderDeadLineSoonLate = function(deadlineDate) {
        if (!deadlineDate) {
            return false;
        }
        return moment(deadlineDate).isBetween(moment(), moment().add(ORDER_DEADLINE_LATE_HOURS, "hours"), undefined, '[)');
    };

    this.isOrderDeadLineLate = function(deadlineDate) {
        if (!deadlineDate) {
            return false;
        }
        return moment(deadlineDate).isBetween(startOfDay, moment(), undefined, '[)');
    };

    this.isOrderDeadLineWarning = function(deadlineDate) {
        if (!deadlineDate) {
            return false;
        }
        return this.isOrderDeadLineSoonLate(deadlineDate) || this.isOrderDeadLineLate(deadlineDate);
    };

    this.filterByPartnershipTags = function(filter) {
        if (filter && filter.length) {
            filter = filter.join(",");
        }
        $scope.filters.selectedPartnershipTagsFilter = filter;
        _this.fetch();
    };

    this.fetch = function() {
        angular.extend($scope.params, $scope.lastOrderDateFilters[$scope.filters.selectedLastOrderDateFilter]);
        angular.extend($scope.params, {partnership_last_order_date_filter: $scope.filters.selectedLastOrderDateFilter});
        angular.extend($scope.params, $scope.lastInvoiceDateFilters[$scope.filters.selectedLastInvoiceDateFilter]);
        angular.extend($scope.params, {last_invoice_date_filter: $scope.filters.selectedLastInvoiceDateFilter});
        angular.extend($scope.params, $scope.orderDeadlineFilters[$scope.filters.selectedOrderDeadlineFilter]);
        angular.extend($scope.params, {order_deadline_filter: $scope.filters.selectedOrderDeadlineFilter});
        angular.extend($scope.params, {tags: $scope.filters.selectedPartnershipTagsFilter});

        StateExtensionService.updateUrlParams($scope.params);
        angular.extend($scope.cachedFilters[$state.current.name], $scope.params);
        $cookies.putObject("filters", $scope.cachedFilters);

        UserPartnershipService.query($scope.params).$promise
        .then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.userPartnerships = data.results;
            mergeUserCustomerDistributorData();
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    };

    function mergeUserCustomerDistributorData() {
        if ($scope.orderConsolidationPartnerships && $scope.orderConsolidationPartnerships.length && $scope.userPartnerships.length) {
            $scope.userPartnerships.some(function(userPartnership) {
                if (userPartnership.is_order_consolidation_order_source) {
                    $scope.orderConsolidationPartnerships.some(function(partnership) {
                        if (userPartnership.id === partnership.partnership_id) {
                            userPartnership.distributorData = partnership;
                        }
                    });
                }
            });
        }
    }

    this.choose = function(userCustomerId) {
        UserCustomerService.choose(userCustomerId).$promise
        .then(function onSuccess() {
            var updateCurrentNumbers = true;
            UserService.refreshCurrentUser(updateCurrentNumbers).then(function() {
                if ($stateParams.vendor || $stateParams.catalog || $stateParams.product) {
                    $scope.cachedFilters[$state.current.name]['vendor'] = undefined;
                    $scope.cachedFilters[$state.current.name]['catalog'] = undefined;
                    $scope.cachedFilters[$state.current.name]['product'] = undefined;
                    $cookies.putObject("filters", $scope.cachedFilters);
                    $state.go("stocks", {
                        vendorId: $stateParams.vendor,
                        catalog: $stateParams.catalog,
                        product: $stateParams.product
                    });
                }
                else if ($stateParams.vendorInvite) {
                    $scope.cachedFilters[$state.current.name]['vendorInvite'] = undefined;
                    $cookies.putObject("filters", $scope.cachedFilters);
                    PartnershipService.add({"vendorInvite": $stateParams.vendorInvite}).then(
                            function success(data) {
                                FlashBag.success(data.detail, true);
                            },
                            function failed(response) {
                                FlashBag.apiError(response, true);
                            }
                    );
                    $state.go("home");
                }
                else if ($stateParams.groupInvite) {
                    $scope.cachedFilters[$state.current.name]['groupInvite'] = undefined;
                    $cookies.putObject("filters", $scope.cachedFilters);
                    GroupService.addCustomerGroupMembershipFromLogin($stateParams.groupInvite);
                }
                else if ($stateParams.invoice) {
                    $scope.cachedFilters[$state.current.name]['invoice'] = undefined;
                    $cookies.putObject("filters", $scope.cachedFilters);
                    $state.go("invoiceDetails", {id: $stateParams.invoice});
                }
                else if ($stateParams.payment) {
                    $scope.cachedFilters[$state.current.name]['payment'] = undefined;
                    $cookies.putObject("filters", $scope.cachedFilters);
                    $state.go("paymentDetails", {id: $stateParams.payment});
                }
                else if ($stateParams.unpaid_invoices) {
                    $scope.cachedFilters[$state.current.name]['unpaid_invoices'] = undefined;
                    $cookies.putObject("filters", $scope.cachedFilters);
                    $state.go("payment", {selected: $stateParams.unpaid_invoices});
                }
                else {
                    $state.go("home");
                }
            });
        });
    };

    this.goToOrderConsolidation = function(sourcePartnership, orderItemType) {
        var params = {
            'order-item-type': orderItemType,
            'source': sourcePartnership.partnership_id,
        };
        UserCustomerService.choose(sourcePartnership.user_customer_id).$promise
        .then(function onSuccess() {
            UserService.refreshCurrentUser().then(function() {
                $state.go("orderConsolidation", params);
            });
        });
    };

    this.goToReturnOrderConsolidation = function(sourcePartnership) {
        if (
                sourcePartnership.product_suppliers
                && sourcePartnership.product_suppliers.length === 1
                && sourcePartnership.product_suppliers[0].disable_return_consolidation
        ) {
            return;
        }

        this.goToOrderConsolidation(sourcePartnership, 'returns');
    };

    this.goToInvoiceListing = function(userCustomerId) {
        UserCustomerService.choose(userCustomerId).$promise
        .then(function onSuccess() {
            UserService.refreshCurrentUser().then(function() {
                $state.go("invoiceList");
            });
        });
    }

    this.openNoOrderNotificationConfirmation = function(userPartnership) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("../order/no-order-notification/modals/no-order-notification.modal.html"),
            controller: "NoOrderNotificationConfirmationController",
            controllerAs: "noOrderNotificationConfirmationCtrl",
            inputs: {
                $attrs: {
                    customerName: userPartnership.name,
                    deliveryDate: userPartnership.delivery_date,
                }
            }
        }).then(function(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    return;
                }

                NoOrderNotificationService.submitSalesRepEmptyOrder(userPartnership.id).then(function onSuccess() {
                    _this.fetch();
                    var message = gettextCatalog.getString("The no-order notification was sent.");
                    FlashBag.success(message, true);
                });
            });
        });
    };

    this.openPartnershipDetails = function(userPartnershipId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("./modals/user-partnership-details.modal.html"),
            controller: "UserPartnershipDetailsModal",
            controllerAs: "userPartnershipDetailsModalCtrl",
            inputs: {
                $attrs: {
                    partnershipId: userPartnershipId
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            return modal.close;
        });
    };

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        this.fetch();
    };

    function updateSelectedPartnershipTagFilter(tags) {
        $scope.filters.selectedPartnershipTagsFilter = tags;
        if (
                $scope.showDistributorRoutes
                && $scope.orderConsolidationPartnerships
                && $scope.orderConsolidationPartnerships.length
        ) {
            var found = false;
            $scope.orderConsolidationPartnerships.some(function(partnership) {
                if (partnership.tags.length && partnership.tags.join(",") === tags) {
                    $scope.sourcePartnership = partnership;
                    found = true;
                }
            });
            if (!found) {
                $scope.sourcePartnership = null;
            }
        }
    }

    $scope.$on("queryListing", function($event, params) {
        angular.extend($scope.params, params);
        _this.fetch();
    });

    $scope.$on("listingFilterUpdated", function(event, filters) {
        if (filters.clear) {
            $scope.filters.selectedLastOrderDateFilter = $scope.LAST_ORDER_DATE_FILTER_ALL;
            $scope.filters.selectedLastInvoiceDateFilter = $scope.LAST_INVOICE_DATE_FILTER_ALL;
            $scope.filters.selectedOrderDeadlineFilter = $scope.ORDER_DEADLINE_FILTER_ALL;
        }
        else {
            $scope.filters.selectedLastOrderDateFilter = $scope.LAST_ORDER_FILTER_CUSTOM;
            $scope.filters.selectedLastInvoiceDateFilter = $scope.LAST_INVOICE_FILTER_CUSTOM;
            $scope.filters.selectedOrderDeadlineFilter = $scope.ORDER_DEADLINE_FILTER_CUSTOM;
        }
        updateSelectedPartnershipTagFilter(filters['tags'])
        $scope.pagination.current_page = 1;
        angular.extend($scope.params, filters);
        _this.fetch();
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-partnership/user-partnership-list.controller.js
// module id = 944
// module chunks = 0